import * as React from 'react';
import styled from 'styled-components';
import Review, {
    ReviewContent,
    ReviewDetails,
    ReviewRating,
    ReviewReply,
    ReviewTextContent,
    ReviewTranslation,
} from '@westwing/ui-kit/Review';
import { formatDate } from '@westwing/appshell-formatting-helpers';
import { useTranslator } from '@ids/appshell/hooks';
import { ProductReview } from '@ids/types/now-api';

const StyledReviewContent = styled(ReviewContent)`
    padding: 25px 0;
    min-height: 186px;
`;

interface ReviewItemProps {
    review: ProductReview;
}

const ReviewItem = ({ review: { title, message, author, rating, date, original, reply } }: ReviewItemProps) => {
    const t = useTranslator();

    const getReviewDetails = () => {
        const authorName = !author.is_anonymous && author.username ? author.username : t('reviews_Verified customer');
        if (!message) {
            return `${t('reviews_Verified customer from')} ${author.city} ${date && formatDate(date)}`;
        }
        return `${t('reviews_from')} ${authorName} ${t('reviews_on')} ${date && formatDate(date)}`;
    };

    return (
        <Review readMoreText={`(${t('reviews_read more')})`} readLessText={`(${t('reviews_fold')})`}>
            <StyledReviewContent>
                <ReviewTextContent>
                    {!!message && (
                        <ReviewTranslation.Title>
                            {title || `${t('reviews_Verified customer from')} ${author.city}`}
                        </ReviewTranslation.Title>
                    )}
                    <ReviewRating rating={rating} />
                    <ReviewDetails>{getReviewDetails()}</ReviewDetails>
                    <ReviewTranslation.Message>{message || ''}</ReviewTranslation.Message>
                    <ReviewTranslation
                        title={title || `${t('reviews_Verified customer from')} ${author.city}`}
                        message={message || ''}
                        original={original}
                        showTranslationText={t('reviews_translated by google')}
                        showOriginalText={t('reviews_see original message')}
                    />
                </ReviewTextContent>
            </StyledReviewContent>
            <ReviewReply>
                <ReviewReply.Label>{`${t('reviews_Westwing team')} ${t('reviews_on')} ${
                    reply?.date && formatDate(reply.date)
                }`}</ReviewReply.Label>
                <ReviewReply.Text>{reply?.text}</ReviewReply.Text>
            </ReviewReply>
        </Review>
    );
};

export { ReviewItem as default, StyledReviewContent };
